// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1bcEk","col":"styles_col__1TNlG"};